const API_BASE_URL = '/api';
const MAIL_API_URL = '/api/mail';

const apiRoutes = {
  submitForm: `${MAIL_API_URL}/submit-email`,
  healthCheck: `${API_BASE_URL}/health`,
  mailHealth: `${MAIL_API_URL}/health`,
  login: `${API_BASE_URL}/login`,
};

export default apiRoutes;
